import MainPageHeader from './MainPageHeader';

export default MainPageHeader;
